<template>
  <b-container id="app" fluid>
    <b-row class="appHeader">
      <b-col sm="1" >
        <b-img class="headerImage" src="./logo.png" width="100%" align="left" />
      </b-col>
      <b-col>
        <app-nav></app-nav>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="appContent">
        <router-view />
      </b-col>
    </b-row>
    <b-row class="appFooter">
      <b-col>Shades of Polaris, LLC &mdash; Copyright &copy; 2018</b-col>
    </b-row>
  </b-container>
</template>

<script>
import AppNav from "@/components/AppNav";
export default {
  name: "App",
  components: { AppNav },
};
</script>
<style>
body {
  background-color: #dddddd;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  min-height: 95%;
}
.appHeader {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  display: flex;
}
.appFooter {
  position: fixed;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
}
.appContent {
  text-align: center;
}
.headerImage {
  display: inline;
}
</style>